import axios from 'axios';

export type DesignPackageLinkRequest = {
	designId: string;
	/** Numbered kitchen version to pin. Omit/null to follow the design's active version. */
	version?: number | null;
};

export type FetchDesignPackageLinksParams = {
	customerEmail: string;
	designs: Array<DesignPackageLinkRequest>;
	/** Deal to stamp the share link onto (HubSpot `Design Package` field). Omit to skip the CRM write. */
	dealId?: string;
	getAccessTokenSilently: () => Promise<string>;
};

export type DesignPackageLink = {
	designId: string;
	link: string;
};

// Builds the self-contained share links SERVER-SIDE so the base URL comes from the deploy-pipeline's
// PRESENTATION_SWA_URL (the same env the old presentation flow used) — no client base-URL config, and
// still zero writes. Returns a tuple so callers can toast on failure without a throw.
export const fetchDesignPackageLinks = async (params: FetchDesignPackageLinksParams): Promise<[Array<DesignPackageLink> | null, string | null]> => {
	const { customerEmail, designs, dealId, getAccessTokenSilently } = params;

	try {
		const token = await getAccessTokenSilently();
		const apiUrl = import.meta.env.VITE_API_URL;
		const response = await axios.post<{ links: Array<DesignPackageLink> }>(
			`${apiUrl}/design-package-links`,
			{ customerEmail, designs, dealId },
			{ headers: { Authorization: `Bearer ${token}` } }
		);
		return [response.data.links, null];
	} catch {
		return [null, 'Failed to build design package links'];
	}
};
